import logo from './logo.svg';
import sk from './backend/kernel';
import React, { useState } from 'react';
import { useRef } from "react";
import ChatApp from './Log';

// function pythonExec(input) {
//   const pyodide = window.pyodide;

//   pyodide.runPython();
// }

function ParentComponent() {
  const [messageLog, setMessageLog] = useState([]);

  // Callback function to receive and save the current message input
  const handleInputMessage = (message) => {
    setMessageLog([...messageLog, message]);
  };

  return (
    <div>

      <div>
        {messageLog.map((message, index) => (
          <div key={index}>{message}</div>
        ))}
      </div>
      <ChatApp onMessageInput={handleInputMessage} />
    </div>
  );
}

function App() {
  const [state, setState] = useState('')
  return (
    <div className="App">
      <header className="App-header">
          <ParentComponent />
      </header>
    </div>
  );
}

export default App;
